import { isEmptyString } from '@weft/utils';
import type { FieldPath, FieldValues, RegisterOptions, UseFormRegister } from 'react-hook-form';

export function vyFormRegister<FieldValue extends FieldValues, FieldName extends FieldPath<FieldValue>>(
  register: UseFormRegister<FieldValue>,
  fieldPath: FieldName,
  options?: RegisterOptions<FieldValue, FieldName>,
) {
  return register<FieldName>(fieldPath, {
    ...options,
    setValueAs: (val: string) => isEmptyString(val) ? undefined : val,
  });
}